if (!customElements.get('kk-category-scroll')) {
  customElements.define('kk-category-scroll', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('nav');
      this.buttons = [...this.querySelectorAll('button[data-direction]')];
      if (!this.nav || this.buttons.length !== 2) return;
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.setAttribute('data-enhanced', '');
      this.buttons.forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          this.nav.scrollBy({
            left: Number(button.dataset.direction) * Math.max(160, this.nav.clientWidth * .75),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, options);
      });
      this.update = () => {
        const limit = this.nav.scrollWidth - this.nav.clientWidth;
        const position = this.nav.scrollLeft;
        const rtl = getComputedStyle(this.nav).direction === 'rtl';
        this.buttons[0].disabled = rtl ? position <= -limit + 2 : position <= 2;
        this.buttons[1].disabled = rtl ? position >= -2 : position >= limit - 2;
      };
      this.nav.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.nav);
      [...this.nav.children].forEach((link) => this.observer.observe(link));
      this.update();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
    }
  });
}
